"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tile = Tile;
const react_1 = __importDefault(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const react_jss_1 = require("react-jss");
const board_1 = require("@creature-chess/board");
const context_1 = require("../context");
const useStyles = (0, react_jss_1.createUseStyles)({
    tile: {
        position: "relative",
        display: "inline-block",
        boxSizing: "border-box",
        userSelect: "none",
    },
});
function Tile({ x, y, onClick, className }) {
    const styles = useStyles();
    const tileBackgroundRenderer = (0, context_1.useTileBackgroundRenderer)();
    const handleClick = react_1.default.useCallback(() => {
        if (onClick) {
            onClick({ x, y });
        }
    }, [onClick, x, y]);
    return (react_1.default.createElement("div", { className: (0, classnames_1.default)(styles.tile, className), onPointerUp: handleClick }, tileBackgroundRenderer && tileBackgroundRenderer((0, board_1.packPosition)(x, y))));
}
